"use strict";

import Vue from "vue";

Vue.filter("iconClass", teamName => {
  let className = "icon";

  if (teamName) {
    teamName = teamName.toLowerCase().replace(/[^a-zA-Z]/g, "");
    className += ` icon--${teamName}`;
  }

  return className;
});
